/**
 * ObjectDateField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// 3rd party components
import {DatePicker} from 'material-ui-pickers';

// application
import {toLocalISODateString} from '../../utils';


/**
 * ObjectDateField is an editing component for date fields of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectDateField extends React.Component {

    render() {

        return <DatePicker
            keyboard
            label={this.props.fieldDef.name}
            format="dd.MM.yyyy"
            mask={value => (value ? [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/] : [])}
            value={this.props.value ? new Date(this.props.value) : null}
            disabled={this.props.readOnly}
            clearable={true}
            onChange={value => this.props.onObjectValueChange(
                this.props.fieldDef.id, value != null ? toLocalISODateString(value) : undefined
            )}
            disableOpenOnEnter
            animateYearScrolling={false}
            maxDate={'2200-12-31'}
            minDate={'1800-01-01'}
            fullWidth={true}
            margin="normal"
            invalidDateMessage="ungültiges Datumsformat"
        />;
    }
}

ObjectDateField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

export default ObjectDateField;